<template>
  <div class="col">
    <div class="row limit-table" style="overflow-x: hidden">
      <table class="table">
        <thead class="letter-orange">
          <tr>
            <th scope="col">Título</th>
            <th scope="col">Quantidade de Comentários</th>
            <th scope="col">Obra</th>
            <th scope="col">Data de Postagem</th>
            <th scope="col">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="post in posts" v-bind:key="post.id">
            <th scope="row">
              {{ post.title }}
            </th>
            <td>
              {{ post.comments_count }}
            </td>
            <td>
              {{ post.construction.identifier_name }}
              <span class="text-primary" style="cursor: pointer"
                ><i
                  @click="editConstruction(post.construction.id)"
                  class="fas fa-external-link-alt"
                ></i
              ></span>
            </td>
            <td>
              {{ post.created_at }}
            </td>
            <td>
              <div
                @click="viewPost(post.construction.id, post.id)"
                class="btn btn-warning mr-1"
              >
                <i class="fas fa-eye" aria-label="Ver ou Editar"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Stack, StackItem } from 'vue-stack-grid';
import { mapActions, mapGetters, mapState } from 'vuex';
import Card from '../../../components/Journal/Card.vue';
import makeToast from '../../../mixins/makeToast';

export default {
  name: 'journal',
  mixins: [makeToast],
  components: { Stack, StackItem, Card },
  data() {
    return {
      posts: [],
      Fields: {
        name: '',
      },
    };
  },
  computed: {
    ...mapState(['token', 'dadosUsuario']),
    ...mapGetters('journal', ['setPosts']),
  },
  created() {
    this.getUserConstructionsPosts({
      userId: this.dadosUsuario.id,
    })
      .then((response) => {
        console.log(response);
        this.posts = response.data.data;
      })
      .catch((error) => {
        console.log(this.dadosUsuario.id);
        this.makeToast(
          'Oopss!',
          'Não foi possivel carregar as postagens!',
          'danger'
        );
      });
  },
  methods: {
    ...mapActions('journal', ['getUserConstructionsPosts']),
    editConstruction(id) {
      this.$router.push({
        name: 'journal-view-edit-construction',
        params: { id },
      });
    },
    viewPost(id, postId) {
      this.$router.push({
        name: 'journal-view-edit-post',
        params: { id, postId },
      });
    },
  },
};
</script>

<style scoped>
.border-radius {
  border-radius: 8px;
}

.no-text-decoration:hover {
  color: var(--orange-primary);
  text-decoration: none;
}

.table td,
.table th {
  vertical-align: middle;
}
</style>
